import { render, staticRenderFns } from "./sel-tc-user.vue?vue&type=template&id=31cefa5e&"
import script from "./sel-tc-user.vue?vue&type=script&lang=js&"
export * from "./sel-tc-user.vue?vue&type=script&lang=js&"
import style0 from "./sel-tc-user.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports